import { localize } from "utils/localizer";

const i18n = {
    cancel: {
        en: "Cancel",
        de: "Abbrechen",
    },
    clubKey: {
        en: "Location Key",
        de: "Sportstätten-Schlüssel",
    },
    code: {
        en: "Code",
        de: "Code",
    },
    confirmPassword: {
        en: "Confirm password",
        de: "Passwort bestätigen",
    },
    dashboardLogin: {
        en: "Dashboard Login",
        de: "Dashboard Anmeldung",
    },
    emailAddress: {
        en: "E-Mail Address",
        de: "E-Mail Adresse",
    },
    errors: {
        en: {
            // amplify errors
            AuthError: "Please enter your e-mail address and password.",
            CodeMismatchException: "Incorrect code.",
            InvalidParameterException: "Please enter your e-mail address and password.",
            NotAuthorizedException: "Incorrect e-mail address or password.",
            UsernameExistsException: "A user with this e-mail address is already registered.",
            UserNotFoundException: "The user you entered does not exist. Please make sure you are signed up.",

            // api errors
            firstOrLastNameEmpty: "Please enter your first and last name.",
            invalidClubKey: "No location with this key found.",
            passwordPolicy: "The password needs to be at least 6 characters long and must contain uppercase letters.",
            passwordsDontMatch: "Passwords do not match.",
            mfaCodeFormat: "Invalid 2FA code format.",
            userDoesNotExist: "The user you entered does not exist. Please make sure you are signed up.",
        },
        de: {
            // amplify errors
            AuthError: "Gib bitte deine E-Mail Adresse und Passwort ein.",
            CodeMismatchException: "Ungültiger Code.",
            InvalidParameterException: "Gib bitte deine E-Mail Adresse und Passwort ein.",
            NotAuthorizedException: "E-Mail Adresse oder Passwort ungültig.",
            UsernameExistsException: "Es ist bereits ein Benutzer mit dieser E-Mail Adresse registriert.",
            UserNotFoundException: "Der eingegebene Benutzer existiert nicht. Bitte stell sicher, dass du registriert bist.",

            // api errors
            firstOrLastNameEmpty: "Gib bitte deinen Vor- und Nachnamen ein.",
            invalidClubKey: "Keine Sportstätte mit diesem Schlüssel gefunden.",
            passwordPolicy: "Das Passwort muss mindestens 6 Zeichen lang sein, davon mindestens ein Großbuchstabe.",
            passwordsDontMatch: "Passwörter stimmen nicht überein.",
            mfaCodeFormat: "Ungültiges 2FA-Code Format.",
            userDoesNotExist: "Der eingegebene Benutzer existiert nicht. Bitte stell sicher, dass du registriert bist.",
        },
    },
    firstName: {
        en: "First Name",
        de: "Vorname",
    },
    forgotPassword: {
        en: "Forgot Password",
        de: "Passwort vergessen",
    },
    forgotPasswordDesc: {
        en: "Please provide your e-mail address so that we can send you a code to reset your password. For alias accounts, a new PIN will be sent to the main account.",
        de: "Bitte gib deine E-Mail Adresse ein, damit wir dir einen Code zum Zurücksetzen deines Passworts senden können. Bei Alias-Accounts wird eine neue PIN an das Hauptkonto versendet.",
    },
    forgotPasswordCodeSentDesc: {
        en: "Please provide the code we sent you and set a new password.",
        de: "Bitte gib den dir zugeschickten Code ein und lege ein neues Passwort fest.",
    },
    lastName: {
        en: "Last Name",
        de: "Nachname",
    },
    newPassword: {
        en: "New password",
        de: "Neues Passwort",
    },
    newPasswordRequiredDesc: {
        en: "Since this is your first login, please set a new password.",
        de: "Da dies deine erste Anmeldung ist, lege bitte ein neues Passwort fest.",
    },
    newPasswordRequiredTitle: {
        en: "New Password Required",
        de: "Neues Passwort festlegen",
    },
    mfaCodeRequiredDesc: {
        en: "Please enter a 2FA code from your authenticator app.",
        de: "Bitte gib einen 2FA-Code aus deiner Authenticator-App ein.",
    },
    mfaCodeRequiredTitle: {
        en: "2FA Code Required",
        de: "2FA Code Benötigt",
    },
    mfaCode: {
        en: "2FA code",
        de: "2FA-Code",
    },
    ok: {
        en: "Ok",
        de: "Ok",
    },
    or: {
        en: "or",
        de: "oder",
    },
    password: {
        en: "Password",
        de: "Passwort",
    },
    sadIE: {
        en: "Sorry, your browser is currently not supported. Please try ",
        de: "Sorry, dein Browser wird derzeit nicht unterstützt. Versuche es bitte mit ",
    },
    signIn: {
        en: "Sign In",
        de: "Anmelden",
    },
    signInAsDashboard: {
        en: "Sign in as dashboard",
        de: "Als Dashboard anmelden",
    },
    signInAsUser: {
        en: "Sign in as user",
        de: "Als Benutzer anmelden",
    },
    signUp: {
        en: "Sign Up",
        de: "Registrieren",
    },
    userLogin: {
        en: "User Login",
        de: "Benutzer Anmeldung",
    },
    withApple: {
        en: "With Apple",
        de: "Mit Apple",
    },
    withGoogle: {
        en: "With Google",
        de: "Mit Google",
    },
    orLable: {
        en: "OR",
        de: "ODER",
    },
    signInWithApple: {
        en: "Sign in with Apple",
        de: "Anmeldung mit Apple",
    },
    signInWithGoogle: {
        en: "Sign in with Google",
        de: "Anmeldung mit Google",
    },
    permissionDeniedTitle: {
        en: "Permission denied",
        de: "Zugriff verweigert",
    },
    permissionDeniedMessage: {
        en: "Company profile accounts can not use the dashboard",
        de: "Unternehmensprofilkonten können das Dashboard nicht verwenden",
    },
    signupRequireddMessage: {
        en: "You are not a PLAYSPORTS valid user. Make sure you are signed up in PLAYSPORTS mobile app",
        de: "Sie sind kein gültiger PLAYSPORTS-Benutzer. Stellen Sie sicher, dass Sie bei PLAYSPORTS angemeldet sind",
    },
    downloadMobileApp: {
        en: "[Download mobile app](https://playsports.world/download)",
        de: "[Laden Sie die mobile App herunter](https://playsports.world/download)",
    },
};

export default localize(i18n);
